import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/axios-config";  // installs global axios 401 → /login interceptor
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
